var exports = {
  "k": "xcc377c0b--53d547--container",
};

module.exports = exports;
